import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useTenantConfig } from '../hooks/useTenantConfig';
import { useCustomDisplayFormats } from '../hooks/useCustomDisplayFormats';
import { setFormatLocale, registerCustomFormats } from '../services/formatting.service';

/**
 * Syncs tenant-level formatting config into the formatting service's
 * module-level state: the number locale and the set of custom display formats.
 * Renders nothing — just keeps the globals in sync.
 */
export function FormatLocaleProvider({ children }: { children: ReactNode }) {
  const { data: config } = useTenantConfig();
  const { data: customFormats } = useCustomDisplayFormats();

  useEffect(() => {
    if (config?.format_locale) {
      setFormatLocale(config.format_locale);
    }
  }, [config?.format_locale]);

  useEffect(() => {
    registerCustomFormats(customFormats ?? []);
  }, [customFormats]);

  return <>{children}</>;
}
